
    <div
      style="display:flex; align-items:center; justify-content: space-between;"
    >
      <h1 mat-dialog-title style="margin-bottom:0px;">Cards</h1>

      <button mat-button (click)="addCard()">Add Card</button>
    </div>

    <div mat-dialog-content style="overflow:visible;">
      <div
        *ngFor="let card of data"
        style="display:flex; align-items:center; justify-content: space-between;"
      >
        <div
          style="border:1px solid #e5e5e5;border-radius:2%;margin-top:10px;width: 350px;padding:0 15px;"
        >
          <img
            src="assets/images/cards.png"
            style="padding:5px 10px;height:50px;"
          />

          <span style="font-size:14px;font-weight:800;"
            >Ending in {{ getLastFourDigit(card.lastFourDigit) }}</span
          >
        </div>

        <mat-radio-button
          [value]="card"
          (change)="handleChange($event)"
        ></mat-radio-button>
      </div>
    </div>

    <div mat-dialog-actions style="justify-content: end;">
      <button mat-button (click)="close()">Close</button>
      <button mat-button (click)="pay()">Pay</button>
    </div>
  